import { down_arrow, settings_icon, add_account_icon } from '../../../utils/images';
import { Popover, PopoverClose, PopoverContent, PopoverTrigger } from '../../../components/ui/popover';
import { generateCustomAvatar } from '../../..//utils';
import { Skeleton } from '../../../components/ui/skeleton';
import { useState, useEffect } from 'react';
import { userFullNameBuilder } from '../../../utils/userFullNameBuilder';
import store from '../../../rematch';
import { useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router';

const UserMenu = ({ logout, userData, handleSettingOpen, loading }) => {
  const [hovered, setHovered] = useState(false);
  const handleMouseEnterLogoutIcon = () => setHovered(true);
  const handleMouseLeaveLogoutIcon = () => setHovered(false);
  const { fname, preferredFname, lname } = userData;
  const fullName = userFullNameBuilder.build(preferredFname, fname, lname);
  const { dispatch } = store;
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    void dispatch.associatedAccountsModel.getAssociatedAccounts();
  }, []);

  const associatedAccounts = useSelector(state => state.associatedAccountsModel.associatedAccountsList);

  const handleSwitchAccount = async accountSelectedUserId => {
    const response = await dispatch.associatedAccountsModel.switchToAssociatedAccount(accountSelectedUserId);
    if (response.success) {
      const currentLocation = location.pathname;
      // Keep the user on the current page after switching accounts,
      // but redirect to the main page to prevent displaying stale user-specific data
      if (currentLocation.includes('content')) {
        navigate('/content');
      } else if (currentLocation.includes('events')) {
        navigate('/events');
      } else if (currentLocation.includes('mentees')) {
        navigate('/mentees');
      } else if (currentLocation.includes('messages')) {
        navigate('/messages');
      } else {
        navigate('/home');
      }
      // reload page to fetch new user specific data
      window.location.reload();
    } else {
      dispatch.toastModel.showToast({
        value: 'Danger',
        message: response.message,
      });
    }
  };

  return (
    <Popover>
      {loading ? (
        <>
          <div className=" d_flex_center cursor_pointer">
            <span className="profle_img mr-6">
              <Skeleton className="min-h-[40px] min-w-[40px] rounded-full " />
            </span>
            <span className="user_name">
              <Skeleton className="min-h-[15px] min-w-[120px] mr-6 mb-3" />
              <span>
                <Skeleton className="min-h-[10px] max-w-[80px] mr-6" />
              </span>
            </span>
            <img src={down_arrow} alt="" />
          </div>
        </>
      ) : (
        <PopoverTrigger asChild>
          <div className="profile_info d_flex_center cursor_pointer">
            <span className="profle_img">
              <img
                src={userData?.profilePic ? userData?.profilePic : generateCustomAvatar(preferredFname || fname, lname)}
                alt=""
              />
            </span>
            <p className="user_name">
              {fullName}
              <img src={down_arrow} alt="" />
              <span>{userData.role}</span>
            </p>
          </div>
        </PopoverTrigger>
      )}

      <PopoverContent className="header_fixed_box">
        <PopoverClose asChild>
          <div className="header_main_box">
            <div className="header_menu_list">
              {associatedAccounts.length > 0 && (
                <div className="header_sub_menu_header">
                  <h6 className="sub_header_text">Switch Accounts</h6>
                </div>
              )}
              {associatedAccounts.length > 0 &&
                associatedAccounts.map(account => {
                  const associatedAccountInfo = account?.accounts?.userDetails;
                  const associatedAccountFirstName =
                    associatedAccountInfo?.preferredFname || associatedAccountInfo?.fname;
                  const associatedAccountFullName = associatedAccountFirstName + ' ' + associatedAccountInfo?.lname;
                  const associatedAccountRegion = account?.accounts?.partnerOrRegionName;
                  const notificationCount = account?.accounts?.notificationCount;

                  return (
                    <div
                      className="sub_account associated_account"
                      onClick={() => handleSwitchAccount(associatedAccountInfo._id)}>
                      <span className="profle_img">
                        <img
                          className="associated_account_profile_pic"
                          src={
                            associatedAccountInfo?.profilePic
                              ? associatedAccountInfo?.profilePic
                              : generateCustomAvatar(
                                  associatedAccountInfo?.preferredFname || associatedAccountInfo?.fname,
                                  associatedAccountInfo?.lname
                                )
                          }
                          alt="associated account profile picture"
                        />
                        {notificationCount > 0 && (
                          <div className="notification_badge">
                            <p className="notification_count">{notificationCount}</p>
                          </div>
                        )}
                      </span>
                      <div>
                        <p className="associated_account_full_name">
                          {associatedAccountFullName.substring(0, 30)}
                          {}
                        </p>
                        <p>{associatedAccountRegion.substring(0, 30)}</p>
                      </div>
                    </div>
                  );
                })}
              {userData.role === 'Mentor' && (
                <div
                  className="sub_account d_flex align_items_center"
                  style={{ height: '3.7 rem' }}
                  onClick={() => navigate('/add-account')}>
                  <span>
                    <img src={add_account_icon} alt="Add Account" />
                  </span>
                  <div className="u_name">
                    <h6>Add Account</h6>
                  </div>
                </div>
              )}
              {associatedAccounts.length > 0 && (
                <div className="header_sub_menu_header">
                  <h6 className="sub_header_text">More Options</h6>
                </div>
              )}
              <div class="sub_account d_flex align_items_center" onClick={() => handleSettingOpen()}>
                <span>
                  <img src={settings_icon} alt="settings" />
                </span>
                <div class="u_name">
                  <h6>Settings</h6>
                </div>
              </div>
              <div
                class="sub_account d_flex align_items_center logout"
                onClick={() => logout()}
                onMouseEnter={handleMouseEnterLogoutIcon}
                onMouseLeave={handleMouseLeaveLogoutIcon}>
                <span>
                  <svg width="25" height="25" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M4.49999 5.25C4.49999 5.66421 4.83578 6 5.24999 6C5.6642 6 5.99999 5.66421 5.99999 5.25H4.49999ZM5.99999 12.75C5.99999 12.3358 5.6642 12 5.24999 12C4.83578 12 4.49999 12.3358 4.49999 12.75H5.99999ZM6.069 15.5865L6.4095 14.9183L6.4095 14.9183L6.069 15.5865ZM5.41348 14.931L4.74523 15.2715L4.74523 15.2715L5.41348 14.931ZM15.5865 14.931L16.2548 15.2715V15.2715L15.5865 14.931ZM14.931 15.5865L14.5905 14.9183L14.5905 14.9183L14.931 15.5865ZM14.931 2.41349L14.5905 3.08174L14.5905 3.08175L14.931 2.41349ZM15.5865 3.06901L14.9182 3.40951V3.40951L15.5865 3.06901ZM5.41348 3.06901L6.08174 3.40951L5.41348 3.06901ZM6.069 2.41349L5.72851 1.74524V1.74524L6.069 2.41349ZM10.5 9.75C10.9142 9.75 11.25 9.41421 11.25 9C11.25 8.58579 10.9142 8.25 10.5 8.25V9.75ZM2.24999 8.25C1.83578 8.25 1.49999 8.58579 1.49999 9C1.49999 9.41421 1.83578 9.75 2.24999 9.75V8.25ZM3.62403 7.16603C3.85379 6.82138 3.76066 6.35573 3.41601 6.12596C3.07137 5.8962 2.60572 5.98933 2.37595 6.33397L3.62403 7.16603ZM1.63866 8.79199L2.2627 9.20801H2.2627L1.63866 8.79199ZM1.63866 9.20801L2.2627 8.79199L1.63866 9.20801ZM2.37595 11.666C2.60572 12.0107 3.07137 12.1038 3.41601 11.874C3.76066 11.6443 3.85379 11.1786 3.62403 10.834L2.37595 11.666ZM5.99999 5.25V4.65H4.49999V5.25H5.99999ZM7.64999 3H13.35V1.5H7.64999V3ZM15 4.65V13.35H16.5V4.65H15ZM13.35 15H7.64999V16.5H13.35V15ZM5.99999 13.35V12.75H4.49999V13.35H5.99999ZM7.64999 15C7.21757 15 6.93837 14.9994 6.72587 14.9821C6.52212 14.9654 6.44658 14.9372 6.4095 14.9183L5.72851 16.2548C6.0123 16.3994 6.30721 16.4528 6.60372 16.4771C6.89147 16.5006 7.24233 16.5 7.64999 16.5V15ZM4.49999 13.35C4.49999 13.7577 4.49941 14.1085 4.52292 14.3963C4.54714 14.6928 4.60063 14.9877 4.74523 15.2715L6.08174 14.5905C6.06284 14.5534 6.03458 14.4779 6.01794 14.2741C6.00057 14.0616 5.99999 13.7824 5.99999 13.35H4.49999ZM6.4095 14.9183C6.26838 14.8464 6.15364 14.7316 6.08173 14.5905L4.74523 15.2715C4.96094 15.6948 5.30515 16.0391 5.72851 16.2548L6.4095 14.9183ZM15 13.35C15 13.7824 14.9994 14.0616 14.982 14.2741C14.9654 14.4779 14.9371 14.5534 14.9182 14.5905L16.2548 15.2715C16.3994 14.9877 16.4528 14.6928 16.4771 14.3963C16.5006 14.1085 16.5 13.7577 16.5 13.35H15ZM13.35 16.5C13.7577 16.5 14.1085 16.5006 14.3963 16.4771C14.6928 16.4528 14.9877 16.3994 15.2715 16.2548L14.5905 14.9183C14.5534 14.9371 14.4779 14.9654 14.2741 14.9821C14.0616 14.9994 13.7824 15 13.35 15V16.5ZM14.9182 14.5905C14.8463 14.7316 14.7316 14.8464 14.5905 14.9183L15.2715 16.2548C15.6948 16.0391 16.039 15.6948 16.2548 15.2715L14.9182 14.5905ZM13.35 3C13.7824 3 14.0616 3.00058 14.2741 3.01795C14.4779 3.03459 14.5534 3.06285 14.5905 3.08174L15.2715 1.74524C14.9877 1.60064 14.6928 1.54715 14.3963 1.52293C14.1085 1.49942 13.7577 1.5 13.35 1.5V3ZM16.5 4.65C16.5 4.24234 16.5006 3.89148 16.4771 3.60373C16.4528 3.30722 16.3993 3.01231 16.2548 2.72852L14.9182 3.40951C14.9371 3.44659 14.9654 3.52213 14.982 3.72588C14.9994 3.93838 15 4.21758 15 4.65H16.5ZM14.5905 3.08175C14.7316 3.15365 14.8463 3.26838 14.9182 3.40951L16.2548 2.72852C16.039 2.30516 15.6948 1.96095 15.2715 1.74524L14.5905 3.08175ZM5.99999 4.65C5.99999 4.21758 6.00057 3.93838 6.01794 3.72588C6.03458 3.52213 6.06284 3.44659 6.08174 3.40951L4.74523 2.72852C4.60063 3.01231 4.54714 3.30722 4.52292 3.60373C4.49941 3.89148 4.49999 4.24234 4.49999 4.65H5.99999ZM7.64999 1.5C7.24233 1.5 6.89147 1.49942 6.60372 1.52293C6.30721 1.54715 6.0123 1.60064 5.72851 1.74524L6.4095 3.08175C6.44658 3.06285 6.52212 3.03459 6.72587 3.01795C6.93837 3.00058 7.21758 3 7.64999 3V1.5ZM6.08174 3.40951C6.15364 3.26839 6.26838 3.15365 6.4095 3.08175L5.72851 1.74524C5.30515 1.96095 4.96094 2.30516 4.74523 2.72852L6.08174 3.40951ZM10.5 8.25H2.24999V9.75H10.5V8.25ZM2.37595 6.33397L1.01463 8.37596L2.2627 9.20801L3.62403 7.16603L2.37595 6.33397ZM1.01463 9.62404L2.37595 11.666L3.62403 10.834L2.2627 8.79199L1.01463 9.62404ZM1.01463 8.37596C0.762702 8.75385 0.762703 9.24615 1.01463 9.62404L2.2627 8.79199C2.34668 8.91795 2.34668 9.08205 2.2627 9.20801L1.01463 8.37596Z"
                      fill={hovered ? '#C12222' : '#1E2D66'}
                    />
                  </svg>
                </span>
                <div class="u_name">
                  <h6>Logout</h6>
                </div>
              </div>
            </div>
          </div>
        </PopoverClose>
      </PopoverContent>
    </Popover>
  );
};

export default UserMenu;
